(function () {
    'use strict';
    angular
        .module('app')
        .constant('ALFABETO', 'abcdefghijklmnñopqrstuvwxyz')
    ;
})();
